import { isNonNullish } from '@root/helpers';

type ContractValuePillsProps<Value extends string | number> = {
  data?: ReadonlyArray<Value | null | undefined>;
  getLabel?: (value: Value) => string;
};

export const ContractValuePills = <Value extends string | number>({
  data = [],
  getLabel,
}: ContractValuePillsProps<Value>) => {
  return (
    <div className="flex flex-col flex-wrap items-start gap-1.5">
      {data
        .filter(isNonNullish)
        .map((value) => ({ value, label: getLabel ? getLabel(value) : String(value) }))
        // No label means the referenced entity no longer resolves (e.g. a deleted team) — skip the pill.
        .filter(({ label }) => label !== '')
        .map(({ value, label }) => (
          <span
            className="bg-info-100 rounded-lg px-2 py-0.5 text-center text-sm"
            key={value}
            data-testid="contract-value-pill"
          >
            {label}
          </span>
        ))}
    </div>
  );
};
